import React, { Component } from 'react';
import { get, isEqual } from '../../../utils/lodash';

import TrplsTableRowCell from './TrplsTableRowCell';

import TrplCheckbox from '../../TrplControls/TrplCheckbox';
import { isRestrictionOverriden } from '../../../utils';
import { HighlightedTableRow, HighlightedTableCell } from './TableHighlighting';

import { getTransformedTrplsArrayToObj, trplsParamsTable, getColumnId, getNodeColor } from '../../../utils';
import { TitleTableCell } from './TitleTableCell';

export default class TrplsTableRow extends Component {
  state = {
    rowMaxHeight: 170,
    maxCellAncestorsByChain: null,
  };

  componentDidMount() {
    this.setGridToCustomCells();
  };

  componentDidUpdate(prevProps) {
    const { nodeId, individuals } = this.props;

    const oldTrpls = prevProps.individuals.trpls[nodeId];
    const newTrpls = individuals.trpls[nodeId];

    if (this.checkIfTrpslObjectChanged(oldTrpls, newTrpls))
    this.setGridToCustomCells();
  };

  divsAndHeights = (collectedTrplsNodesKeys) => {
    return collectedTrplsNodesKeys.map(divKeys => {
      const keyOfNodes = Object.values(divKeys)[0].join('.');
      const divHeight = document.getElementById(keyOfNodes).offsetHeight;
      const chain = Object.keys(divKeys)[0];

      const oid = Object.values(divKeys)[0][0];
      const sid = Object.values(divKeys)[0][1];
      return {chain, oid, sid, height: divHeight, key: keyOfNodes};
    });
  };

  setGridToCustomCells = () => {
    const collectedTrplsNodesKeys = this.getAllRowTrplsCellsDivsKeys();
    const divsAndHeights = this.divsAndHeights(collectedTrplsNodesKeys);
    
    const sortedByChain = {};
    divsAndHeights.forEach(div => {
      if (sortedByChain[div.chain]) {
        sortedByChain[div.chain].push(div)
      } else {
        sortedByChain[div.chain] = [div];
      }
    });

    const parentChainIds = [];

    Object.keys(sortedByChain).forEach(objectChain => {
      const key = objectChain.split(',');
      if (key.length === 1) parentChainIds.push(key);
    });

    const getCorrespondingChildren = (chain) => {
      return divsAndHeights.filter(div => div.chain.split('').includes(',') && div.chain.includes(chain));
    };

    let childrenHeightSumByOid = [];

    parentChainIds.forEach(chain => {
      const correspondingChilren = getCorrespondingChildren(chain);
      const correspondingChilrenReduced = correspondingChilren.reduce((map, child) => {
        const newChildrenArray = map[child.chain] ? map[child.chain] : [];
          return { ...map, [child.chain]: [...newChildrenArray, child ] }
        }, {});

      let correspondingChildrenWithHeightsByOId = [];
      let theLongestChildWithOids = {};

      if (correspondingChilrenReduced && Object.keys(correspondingChilrenReduced).length) {
        correspondingChilrenReduced && Object.keys(correspondingChilrenReduced).forEach(childrenArrayKey => {
          const childrenHeightsByOidSum = correspondingChilrenReduced[childrenArrayKey].reduce((map, divChild) => {
            return {
              ...map,
              [divChild.oid]: (map[divChild.oid] || 0) + divChild.height,
            }
          }, []);
          if (childrenHeightsByOidSum && (!theLongestChildWithOids ||
            (theLongestChildWithOids && Object.keys(theLongestChildWithOids).length < Object.keys(childrenHeightsByOidSum).length))) {
              theLongestChildWithOids = {...childrenHeightsByOidSum};
          }
          correspondingChildrenWithHeightsByOId = [...correspondingChildrenWithHeightsByOId, childrenHeightsByOidSum];
        });
      }
      if (theLongestChildWithOids)
      correspondingChildrenWithHeightsByOId.map(childObjWithOids => {
        let childObjWithOidsCopy = {...childObjWithOids};
        //if (Object.keys(childObjWithOidsCopy).length < Object.keys(theLongestChildWithOids).length) {
          theLongestChildWithOids && Object.keys(theLongestChildWithOids).forEach(itemOid => {
            if (childObjWithOidsCopy.hasOwnProperty(`${itemOid}`) && (childObjWithOidsCopy[itemOid] > theLongestChildWithOids[itemOid])) {
              theLongestChildWithOids[itemOid] = childObjWithOidsCopy[itemOid];
            } else {
              childObjWithOidsCopy[itemOid] = theLongestChildWithOids[itemOid];
            }
          });
          return childObjWithOidsCopy;
        //}
        //return childObjWithOidsCopy;
      });

      childrenHeightSumByOid.push(theLongestChildWithOids);

      correspondingChildrenWithHeightsByOId.forEach((childrenObjOidsAndHeights, index) => {
        if (Object.keys(childrenObjOidsAndHeights).length) {
          
          const childrenByIndex = Object.values(correspondingChilrenReduced)[index];
          const childrenByOid = childrenByIndex.reduce((byOid, child) => {
            return { ...byOid, [child.oid] : byOid[child.oid] ? [...byOid[child.oid], child] : [child] }
          }, {});

          Object.keys(childrenByOid).forEach(oid => {
            const childsElementsByOid = childrenByOid[oid];
            const childrensSumHeight = childsElementsByOid.reduce((sum, child) => sum + child.height, 0);
            if (childrensSumHeight !== 0 && childrensSumHeight < theLongestChildWithOids[oid]) {
              const lastChild = childsElementsByOid.slice().reverse().find(child => +child.oid === +oid);
              const lastChildElement = document.getElementById(lastChild.key);
              lastChildElement.style.height = `${theLongestChildWithOids[oid]}px`;
            }
          });
        }
      });
    });

    if (!isEqual(this.state.maxCellAncestorsByChain, childrenHeightSumByOid)) {
      const maxCellAncestorsByChain = parentChainIds.reduce((ancestorsByIdObj, chain, index) => {
        return { ...ancestorsByIdObj, [chain]: childrenHeightSumByOid[index] }
      }, {})
      this.setState({ maxCellAncestorsByChain });
    }

    const parentsDivs = divsAndHeights.filter(div => !div.chain.split('').includes(','));

    parentsDivs.forEach(parentDiv => {
      const parentDivInDomCollection = document.getElementsByClassName(`cell-${parentDiv.key}`);
      const collectionToDivsArray = Array.prototype.slice.call(parentDivInDomCollection);

      collectionToDivsArray.forEach(parentDivInDom => {
        const divHeight = parentDivInDom.offsetHeight;
        const childDivs = childrenHeightSumByOid.find(childen => childen[parentDiv.sid]);
        const childDivsHeightsSum = childDivs && childDivs[parentDiv.sid];

        if (childDivsHeightsSum && childDivsHeightsSum > divHeight) {
          parentDivInDom.style.height = `${childDivsHeightsSum}px`;
        } else if (childDivsHeightsSum && childDivsHeightsSum < divHeight) {

          const heightToAddToChildren = divHeight - childDivsHeightsSum;
          const correspondingChilren = getCorrespondingChildren(parentDiv.chain).filter(div => div.oid === parentDiv.sid);
          const lastChild = correspondingChilren && correspondingChilren[correspondingChilren.length - 1];

          const lastChildElement = document.getElementById(lastChild.key);
          const lastChildHeight = lastChildElement.offsetHeight;

          lastChildElement.style.height = `${lastChildHeight + heightToAddToChildren}px`;
        }
      })
    });
  };

  checkIfTrpslObjectChanged = (oldTrpls, newTrpls) => {
    if (oldTrpls === newTrpls) return false;
    else if (!isEqual(oldTrpls, newTrpls)) return true;
    return false;
  };

  shouldComponentUpdate(nextProps, nextState) {
    const { nodeId, individuals, isNew, highlightRow } = this.props;

    const oldTrpls = individuals.trpls[nodeId];
    const newTrpls = nextProps.individuals.trpls[nodeId];

    return (
      highlightRow !== nextProps.highlightRow ||
      this.props.allOntNodes !== nextProps.allOntNodes ||
      this.state.rowMaxHeight !== nextState.rowMaxHeight ||
      this.checkIfTrpslObjectChanged(oldTrpls, newTrpls) ||
      isNew !== nextProps.isNew ||
      this.props.selectedRows.includes(nodeId) !== nextProps.selectedRows.includes(nodeId) ||
      !isEqual(this.props.hideColumns, nextProps.hideColumns) ||
      !isEqual(this.state.cellGroupHeights, nextState.cellGroupHeights) ||
      !isEqual(this.state.maxCellAncestorsByChain, nextState.maxCellAncestorsByChain) ||
      this.props.rowIndex !== nextProps.rowIndex ||
      this.props.rowBorderBold !== nextProps.rowBorderBold
    );
  };

  getAllRowTrplsCellsDivsKeys = () => {
    const { restrictions, trpls, individuals } = this.props;

    const collectedTrplsNodesKeys = [];

    if (restrictions.length) {
      restrictions.forEach(rst => {
        if (rst && rst.custom_pid) {
          const trplsByCastomPid = this.collectTrplsByChainAndNode(rst.custom_pid, trpls, individuals);
    
          if (trplsByCastomPid) {
            const nodesByCastomPid = trplsByCastomPid.map(trpl => trpl && trpl.oid);
            const allAncestorsNodes = trplsByCastomPid.map(trpl => trpl && trpl.sid);

            nodesByCastomPid.forEach((oid, index) => {
              collectedTrplsNodesKeys.push({[rst.custom_pid]: [allAncestorsNodes[index], oid]});
            });
          }
        }
      })
    }

    return collectedTrplsNodesKeys;
  };

  collectTrplsByChainAndNode = (originalPid, trpls, individuals) => {
    if (!originalPid || !trpls || !individuals || !individuals.trpls || !Object.values(individuals.trpls).length) return [];

    let collectedTrpls = [];

    const addChildTrplsToCollected = (chain, t) => {
      const chainCopy = [...chain];
      const parentRstId = chainCopy[0];
      const childRstId = chainCopy[1];

      const parentTrpls = t !== undefined
          ? t
          : trpls && parentRstId && trpls[parentRstId] && Array.isArray(trpls[parentRstId])
          ? trpls[parentRstId]
            : trpls && trpls[parentRstId] ? [[parentRstId]] : [];

      const childTrpls = parentTrpls && parentTrpls
        .filter(Boolean)
        .map((trpl) => get(getTransformedTrplsArrayToObj(individuals.trpls, trpl.oid, trplsParamsTable), [childRstId]))
        .filter(Boolean)
        .flat();

      // if end
      if (chain.length <= 1) {
        collectedTrpls.push(...parentTrpls);
      } else if (chain.length > 1 && chain.length <= 2) {
        collectedTrpls.push(...childTrpls);
      } else {
        chainCopy.shift();

        addChildTrplsToCollected(chainCopy, childTrpls);
      }
    };

    addChildTrplsToCollected(originalPid);

    return collectedTrpls;
  };

  expandCell = (newHeight) => {
    this.setState({ rowMaxHeight: newHeight });
  };

  render() {
    const { rowMaxHeight, maxCellAncestorsByChain } = this.state;
    const {
      trpls,
      nodeId,
      tableId,
      isEmbed,
      account,
      classes,
      settings,
      rowIndex,
      whiteRows,
      selectNode,
      rowsToShow,
      ancestorId,
      individuals,
      hideColumns,
      allOntNodes,
      highlightRow,
      selectedRows,
      restrictions,
      rowBorderBold,
      rowsToShowPage,
      nodeRightsRules,
      openTrplFormFull,
      onRstTypeBtnClick,
      trplSaveDataImport,
      openTrplFormWithRst,
      onNodeRemoveBtnClick,
    } = this.props;

    const node = individuals.nodes[nodeId];

    const showIndex = settings.show_index || tableId === ancestorId;
    const showTitle = settings.show_title || tableId === ancestorId;

    const isSelected = selectedRows.includes(nodeId);

    const rowClassName = `${node && node.isNew ? classes.newNodeFadeOut : classes.tableRow} ${(
        isSelected && !rowBorderBold ? classes.highlightHorisontalRow : ''
      )} ${(
        isSelected && rowBorderBold ? classes.highlightHorisontalRowBold : ''
      )} ${(
        isSelected ? classes.tableRowSelected : ''
      )} ${(
        rowBorderBold ? classes.trpsTableRowBold : ''
      )} ${(
        classes.trpsTableRow )}`;

    const indexCellClassName = `cell-index
      ${classes.tableCellLeft} ${allOntNodes ? classes.indexCellStickyWithMark : classes.indexCellSticky}
      ${rowBorderBold ? classes.tableCellBold : classes.tableCellRegular}`;

    const nodeCellClassName = `cell-node ${classes.tableCellLeft}
      ${rowBorderBold ? classes.tableCellBold : classes.tableCellRegular}
      ${classes.nodeCell}`;

    const markCellClassName = `cell-mark ${classes.tableCellLeft} ${classes.ontologyMarkCellRow}
      ${rowBorderBold ? classes.tableCellBold : classes.tableCellRegular}`;

    const titleForViewOnly = (ancestorId !== tableId) && settings && (!settings.buttons || (settings.buttons && !settings.buttons.editNode));

    return (
      <HighlightedTableRow
        rowBorderBold={rowBorderBold}
        highlightRow={highlightRow}
        rowClassName={rowClassName}
        classes={classes}
        nodeId={nodeId}
        tableId={tableId}
        ancestorId={ancestorId}
      >
        {allOntNodes ?
          <HighlightedTableCell
            isMark={true}
            nodeId={nodeId}
            tableId={tableId}
            ancestorId={ancestorId}
            classes={classes}
            cellClassName={markCellClassName}
          >
            <div title={`ontology: ${individuals.nodes[nodeId].ontology}`}
              className={classes.alignJustifyCenter}
              style={{
                fontSize: 9,
                width: '16px',
                height: '100%',
                position: 'sticky',
                backgroundColor: `${getNodeColor(individuals.nodes[nodeId].ontology)}`,
              }}
            ><strong style={{ color: '#fff' }}>{individuals.nodes[nodeId].ontology}</strong></div>
          </HighlightedTableCell>
        : null}

        {showIndex ? (
          <HighlightedTableCell
            isId={true}
            nodeId={nodeId}
            tableId={tableId}
            ancestorId={ancestorId}
            rstChainId={null}
            cellClassName={indexCellClassName}
            classes={classes}
          >
            <span
              className="row-index-text"
              style={{
                zIndex: 2,
                position: 'relative',
                padding: '2px 5px',
                right: 0,
                display: `${isSelected ? 'none' : ''}`,
              }}
            >
              {rowIndex + 1 + (rowsToShowPage - 1) * rowsToShow}
            </span>

            <TrplCheckbox
              disableRipple
              value={isSelected}
              classes={{
                root: classes.rstCheckboxGray,
                label: classes.rstCheckboxLabel,
              }}
              checked={isSelected}
              onChange={(e) => selectNode(e.target.checked, node.id)}
              className={`row-checkbox ${classes.tableRowCheckbox}`}
              style={{
                zIndex: 2,
                margin: 0,
                position: 'relative',
                display: `${isSelected ? 'flex' : ''}`,
              }}
            />
            <div className={classes.blurBGForCells}></div>
          </HighlightedTableCell>
        ) : null}

        {showTitle ? (
          <HighlightedTableCell
            isTitle={true}
            nodeId={nodeId}
            tableId={tableId}
            rstChainId={null}
            ancestorId={ancestorId}
            cellClassName={nodeCellClassName}
            style={{ backgroundColor: isSelected ? '#DBD9E7' : ''}}
            classes={classes}
          >
            <TitleTableCell
              node={node}
              nodeId={nodeId}
              tableId={tableId}
              classes={classes}
              allOntNodes={allOntNodes}
              openTrplFormFull={openTrplFormFull}
              titleForViewOnly={titleForViewOnly}
            />
          </HighlightedTableCell>
        ) : null}

        {restrictions.map((rst, rstIndex) => {
          const isRestrictionOverrided = isRestrictionOverriden(rst);
          let collectedTrpls = [];

          // collect chain trpls
          if (Array.isArray(rst.id) && trpls) {
            collectedTrpls = this.collectTrplsByChainAndNode(rst.id, trpls, individuals);
          }
          // if hasn't parent - render as is
          else {
            if (trpls) {
              let tempTrpls = trpls[rst.id];

              if (tempTrpls) {
                if (Array.isArray(tempTrpls)) {
                  tempTrpls.forEach((trplEl) => {
                    collectedTrpls.push(trplEl);
                  });
                } else {
                  collectedTrpls.push(tempTrpls);
                }
              }
            }
          }
            
          const rightsRstKey = rst.chainTitle || rst.id;
          const mode = nodeRightsRules && nodeRightsRules[rightsRstKey] ? nodeRightsRules[rightsRstKey]
            : nodeRightsRules && nodeRightsRules.default ? nodeRightsRules.default : 'WRITE';

          const rstChainId = getColumnId(rst);
          return (
            <TrplsTableRowCell
              rst={rst}
              node={node}
              mode={mode}
              trpls={trpls}
              rowIndex={rowIndex}
              whiteRows={highlightRow ? false : whiteRows}
              key={`${rstChainId}.${rstIndex}`}
              nodeId={nodeId}
              tableId={tableId}
              isEmbed={isEmbed}
              classes={classes}
              account={account}
              rstIndex={rstIndex}
              rstChainId={rstChainId}
              isSelected={isSelected}
              ancestorId={ancestorId}
              hideColumns={hideColumns}
              individuals={individuals}
              rowMaxHeight={rowMaxHeight}
              expandCell={this.expandCell}
              rowBorderBold={rowBorderBold}
              collectedTrpls={collectedTrpls}
              openTrplFormFull={openTrplFormFull}
              onRstTypeBtnClick={onRstTypeBtnClick}
              trplSaveDataImport={trplSaveDataImport}
              openTrplFormWithRst={openTrplFormWithRst}
              onNodeRemoveBtnClick={onNodeRemoveBtnClick}
              isRestrictionOverrided={isRestrictionOverrided}
              maxCellAncestorsByChain={maxCellAncestorsByChain}
              collectTrplsByChainAndNode={this.collectTrplsByChainAndNode}
            />
          );
        })}
      </HighlightedTableRow>
    );
  }
};
